export const Menudata=[
    {
        title:"Home",
        url:"/",
        CName:"nav-links",
        icon:"fa-solid fa-house-user"
    },
    {
        title:"Service",
        url:"/service",
        CName:"nav-links",
        icon:"fa-solid fa-briefcase"
    },
    {
        title:"About",
        url:"/about",
        CName:"nav-links",
        icon:"fa-solid fa-circle-info"
    },
   
    {
        title:"Contact",
        url:"/contact",
        CName:"nav-links",
        icon:"fa-solid fa-address-book"
    },
]